module.exports = __webpack_public_path__ + "arrow-down-479c6d3858b48803716c18765601729c.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/arrow-down.svg
// module id = 50
// module chunks = 0